import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';

interface PlatformRoleGateProps {
  /** Only 'super_admin' is used today (Admins management is Super-Admin-only). */
  role: 'super_admin';
  children: React.ReactNode;
  redirectTo?: string;
}

/** Mirrors RoleGate.tsx for the platform-admin identity — a Co-Admin hitting
 * /platform/admins directly is redirected, never shown the admin list. */
export function PlatformRoleGate({ role, children, redirectTo = '/platform' }: PlatformRoleGateProps) {
  const { platformAdmin } = useAuthStore();
  const allowed = platformAdmin?.role === role;

  if (allowed) return <>{children}</>;
  return <Navigate to={redirectTo} replace />;
}
